import React from 'react';
import ReviewsContentButtonFilter
	from '@app/site/secured/review-manager/fragment/reviews-inbox/filter/ReviewsContentButtonFilter';
import { useReviewsTools } from '@app/site/secured/review-manager/provider/useReviewsTools';
import ReviewsProviderButtonFilter
	from '@app/site/secured/review-manager/fragment/reviews-inbox/filter/ReviewsProviderButtonFilter';
import ReviewsRatingButtonFilter
	from '@app/site/secured/review-manager/fragment/reviews-inbox/filter/ReviewsRatingButtonFilter';
import MainPage from '@app/component/page/MainPage';
import ReviewsInboxFragment from '@app/site/secured/review-manager/fragment/reviews-inbox/ReviewsInboxFragment';
import ReviewsCompanyHotelButtonFilter
	from '@app/site/secured/review-manager/fragment/reviews-inbox/filter/ReviewsCompanyHotelButtonFilter';
import ReviewsPeriodButtonFilter
	from '@app/site/secured/review-manager/fragment/reviews-inbox/filter/ReviewsPeriodButtonFilter';
import ReviewsAutoReplyButton
	from '@app/site/secured/review-manager/fragment/reviews-inbox/filter/ReviewsAutoReplyButton';
import ReviewsFilterResetButton
	from '@app/site/secured/review-manager/fragment/reviews-inbox/filter/ReviewsFilterResetButton';

const ReviewManagementInboxPage = React.memo(() => {

	const tools = useReviewsTools();

	return <>
		<div className="bg-white shadow-sm border-t border-gray-200">
			<div className="mx-auto max-w-7xl py-3 px-4 sm:px-6 lg:px-8">
				<div className="md:flex md:items-center md:justify-between ">
					<ReviewsCompanyHotelButtonFilter filter={tools.filter} onFilter={tools.setFilter} />
					<div className="flex flex-wrap gap-x-3 gap-y-2 items-center" />
					<div className="flex flex-wrap gap-x-3 gap-y-2 items-center">
						<ReviewsContentButtonFilter filter={tools.filter} onFilter={tools.setFilter} />
						<ReviewsProviderButtonFilter filter={tools.filter} onFilter={tools.setFilter} />
						<ReviewsRatingButtonFilter filter={tools.filter} onFilter={tools.setFilter} />
						<ReviewsPeriodButtonFilter filter={tools.filter} onFilter={tools.setFilter} />
						<div className="h-4 w-px bg-gray-300 mx-2 hidden sm:block"/>
						<ReviewsAutoReplyButton/>
						<ReviewsFilterResetButton/>
					</div>
				</div>
			</div>
		</div>
		<MainPage>
			<ReviewsInboxFragment />
		</MainPage>
	</>;
});

export default ReviewManagementInboxPage;